import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=1811d28a"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1811d28a')) {
      api.createRecord('1811d28a', component.options)
    } else {
      api.reload('1811d28a', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=1811d28a", function () {
      api.rerender('1811d28a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/Dashboard.vue"
export default component.exports